import useRequestClass from './useRequestClass';

/**
 * Whether the storefront may suggest another country from the geolocation of the visitor (`CountryRedirectPopup`
 * of the brands): never inside the CMS live preview, where the CMS chooses the page, the locale included.
 * @returns {boolean}
 */
const useCountryRedirectSuggestionEnabled = (): boolean => !useRequestClass().isLivePreview;

export default useCountryRedirectSuggestionEnabled;
